import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Images from "assets/images";
import Button from "components/buttons/Button";
import { Icon } from "stories/Icons";
import { useApiMutation } from "hooks/useApiMutation";
import { updateReferralSourceAction } from "api/actions/UserActions";
import { setUserDetails } from "reducers/currentUserReducer";
import { useCurrentUser } from "hooks/useCurrentUser";
import { referral_source_code } from "helpers/enum";

const referralOptions = [
  {
    label: "Google",
    value: "google",
    renderIcon: () => <Icon name="google" className="w-10 h-10" />,
  },
  {
    label: "Instagram",
    value: "instagram",
    renderIcon: () => <img src={Images.InstagramIcon} alt="Instagram" />,
  },
  {
    label: "Facebook",
    value: "facebook",
    renderIcon: () => <img src={Images.FacebookIcon} alt="Facebook" />,
  },
  {
    label: "TikTok",
    value: "tiktok",
    renderIcon: () => <img src={Images.TikTokIcon} alt="TikTok" />,
  },
  {
    label: "Doctor's Referral",
    value: "doctor_referral",
    renderIcon: () => <img src={Images.DoctorReferralIcon} alt="Doctor Referral" />,
  },
  {
    label: "Friend/Family",
    value: "friend_or_family",
    renderIcon: () => <img src={Images.FriendFamilyIcon} alt="Friend/Family" />,
  },
  {
    label: "Other",
    value: "other",
    renderIcon: () => <img src={Images.OthersIcon} alt="Other" />,
  },
];

function ReferralSource({ setActiveIndex, visitId, onLeaveReferralStep }) {
  const dispatch = useDispatch();
  const { userDetails: currentUserDetails } = useCurrentUser();
  const [selectedSource, setSelectedSource] = useState(null);
  const [otherText, setOtherText] = useState('');
  const { mutate: callUpdateReferralSource, loading } = useApiMutation(
    updateReferralSourceAction
  );

  useEffect(() => {
    const rawReferralSource = currentUserDetails?.referral_source;
    const rawReferralSourceOtherText = currentUserDetails?.referral_source_other;
    if (referralOptions.some((option) => option.value === rawReferralSource)) {
      setSelectedSource(rawReferralSource);
      setOtherText(rawReferralSourceOtherText || '');
    }
  }, [currentUserDetails?.referral_source, currentUserDetails?.referral_source_other]);

  function goToNextStep() {
    onLeaveReferralStep?.();
    setActiveIndex((prev) => (typeof prev === "number" ? prev + 1 : prev));
  }

  function handleContinue() {
    if (!selectedSource) {
      goToNextStep();
      return;
    }

    callUpdateReferralSource({
      referral_source: referral_source_code[selectedSource],
      referral_source_visit_id: visitId ?? null,
      ...(selectedSource === 'other' && {referral_source_other: otherText.trim()})
    }).then((response) => {
      if (response?.error !== true) {
        dispatch(
          setUserDetails({
            userDetails: {
              ...currentUserDetails,
              referral_source: selectedSource,
              referral_source_other: otherText.trim(),
            },
          })
        );
        goToNextStep();
      }
    });
  }

  return (
    <div className="bg-white rounded-b-4xl p-10 pt-0 relative overflow-x-hidden">
        <div className="space-y-6">
          {referralOptions.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => setSelectedSource(option.value)}
              className={`w-full p-6 border rounded-xl flex items-center justify-between ${
                selectedSource === option.value ? "border-orange" : "border-borderColor"
              }`}
            >
              <div className="flex items-center">
                <div className="w-10 h-10 flex items-center justify-center">
                  {option.renderIcon ? (
                    option.renderIcon()
                  ) : (
                    <div className="w-9 h-9 rounded-full bg-indigo bg-opacity-10" />
                  )}
                </div>
                <p className="pl-6 text-2xl font-medium text-indigo">{option.label}</p>
              </div>
              <img
                className="w-10 h-10"
                src={
                  selectedSource === option.value
                    ? Images.radioChecked
                    : Images.uncheckedCircle
                }
                alt="radio"
              />
            </button>
          ))}
          {selectedSource === "other" && <div className="mt-6">
            <input type='text' 
              placeholder="Please specify other sources if any (Max 200 chars)" 
              className="w-full p-6 border-b font-medium text-2xl outline-black outline-1"
              value={otherText} onChange={(e) => setOtherText(e.target.value)}
              maxLength={200}
            />
          </div>}
          <Button
            className="py-4 mt-6"
            loading={loading}
            label="Next"
            type="button"
            onClick={handleContinue}
            disabled={selectedSource === "other" && otherText.trim() === ""}
          />
        </div>
      
    </div>
  );
}

export default ReferralSource;
